// Types kept verbatim from the old Apollo codegen models (src/models/*/<Operation>.ts, globalTypes.ts).
// Not produced by graphql-codegen: enums whose runtime values must stay unchanged (mapped via
// `enumValues` in codegen.ts), and models/operations that no longer exist in the schema.
export enum CompanySourceEntity {
  UK = "W2V-UK",
  RBC = "RBC",
  ES = "W2V-ES-DIVA",
  IL = "W2V-IL",
}

export enum InactiveReason {
  ContractEnded = "ContractEnded",
  PricingDisagreement = "PricingDisagreement",
  CommercialTermsNotAgreed = "CommercialTermsNotAgreed",
  NoDataReceived = "NoDataReceived",
  Duplicate = "Duplicate",
  ProductLimitations = "ProductLimitations",
  ServiceDidNotMeetExpectations = "ServiceDidNotMeetExpectations",
  ClientMovedToAlternativeSolution = "ClientMovedToAlternativeSolution",
  LegalIssues = "LegalIssues",
  RecreatedUnderDifferentAccount = "RecreatedUnderDifferentAccount"
}
